export * from './alert.service';
export * from './authentication.service';
export * from './pager.service';
export * from './quotation.service';
export * from './fare.service';
export * from './excel.service';
export * from './message.service';
export * from './locations.service';
export * from './transportation.service';
export * from './loading.service';
export * from './cfs.service';
export * from './consults.service';
export * from './user.service';
export * from './forwarder.service';
export * from './banner.service';
export * from './promotion.service';
export * from './vessel.service';
export * from './fleet.service';
export * from './common.service';
export * from './board.service';
export * from './unipass.service';
export * from './schedule.service';
export * from './sales/consulting-monitoring.service';
export * from './sales/sales-manager.service';
export * from './gmap-log.service'


// WEBPACK FOOTER //
// ./src/app/services/index.ts